const sanitizeSlug = slugString => {
  let slug = "";
  // Change to lower case
  let slugStringLower = slugString.toLowerCase();
  // Letter "e"
  slug = slugStringLower.replace(/e|é|è|ẽ|ẻ|ẹ|ę|ė|ê|ế|ề|ễ|ể|ệ/gi, "e");
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ą|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ū|ų|ự/gi, "u");
  // Letter "c"
  slug = slug.replace(/č|ç|ć/gi, "c");
  // Letter "s"
  slug = slug.replace(/š|ś/gi, "s");
  // Letter "z"
  slug = slug.replace(/ž|ź|ż/gi, "z");
  // Letter "i"
  slug = slug.replace(/į|î|ï|ì|ī|í/gi, "i");
  // Letter "d"
  slug = slug.replace(/đ/gi, "d");
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, "");
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, "-");
  // Remove symbols
  slug = slug.replace(/[|*$+?&~.()'"!:;,@]/g, "");

  return slug;
};

export { sanitizeSlug };
